module.exports = __webpack_public_path__ + "img/icon-seat.a7161d28.svg";